import React,{useState} from 'react';
import {Helmet} from "react-helmet";
import Footer from "../../Component/Footer/Footer";
import ScrollingMarquee from "../../Component/SupportSection/ScrollingMarquee.jsx";
import './contact_style.css'
//import { Link } from "react-router-dom";
 import 'react-phone-number-input/style.css'
//import BetaForm from "../../Component/BetaForm/index.jsx";
import { Link } from 'react-router-dom';
import Aiheader from '../RentAI/AIheader.jsx';
import BetaWaitlist from '../../Component/Beta-Waitlist/BetaWaitlist.jsx';
import Getstarted from '../../Component/GetStarted/Getstarted.jsx';

const Contactuspage = () => {

    const [showWaitlist, setShowWaitlist] = useState(false);
     const [showGetstarted, setShowGetstared] = useState(false);
 
    return (
        <>
        <Helmet>
            <title>Contact Us | RentId - Get in Touch with Our Team</title>
            <meta property="og:title" content="Contact Us | RentId - Get in Touch with Our Team" />
            <meta name="twitter:title" content="Contact Us | RentId - Get in Touch with Our Team" />
            <meta name="description" content="Have questions about RentId? Contact us today for support, inquiries, and assistance. We're here to help your rental business thrive." />
            <meta name="twitter:description" content="Need assistance? Contact RentId for inquiries, general questions, and support. We’re here to help your rental business succeed." />
            <meta property="og:description" content="Need assistance? Contact RentId for inquiries, general questions, and support. We’re here to help your rental business succeed." />
            <meta name="keywords" content="RentId contact, rental business support, customer service, RentId help, rental solutions, contact RentId" />
            <meta property="og:url" content="https://www.rentid.io/contact_us" />
            <link rel="canonical" href="https://www.rentid.io/contact_us" />
        </Helmet>
        <Aiheader/>
        <BetaWaitlist
        showJoinWaitList={showWaitlist}
        onClose={() => setShowWaitlist(false)}
        onOpen={() => setShowWaitlist(true)}
        //flag={priority-waitlist}
        />

           <Getstarted
            showJoinWaitList={showGetstarted}
            onClose={() => setShowGetstared(false)}
            onOpen={() => setShowGetstared(true)}
            />

            {/* START bannerContactMain */}
            <section className="bannerContactMain">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="bannerContactLeft">
                                <small>CONTACT US</small>
                                <h1>We’re here to help. Let us know how.</h1>
                                <p>Have questions or need assistance? Whether you’re just getting started or already part of 
                                the Rentid community, our team is ready to support you. Let’s keep your rental business 
                                moving forward</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerContactMain */}

            {/* START signupDriveMain */}
            <section className='signupDriveMain'>
                <div className='container'> 
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='headSignupDrive'>
                                <h2>Sign up to drive rentals and growth</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner'>
                                {/* <h3>Sign up for Rentid Waitlist</h3> */}
                                <h3>Sign up for Rentid</h3>
                                <p>Be the first to unlock tools and resources that drive your rental business forward.</p>
                                {/* <a onClick={()=> setShowWaitlist(true)} className="btn btnBlue">Sign Up</a> */}
                                <button type='button' className="btn btnGrad_1">Coming Soon</button>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner'>
                                {/* <h3>Join Rentid Beta Program</h3> */}
                                <h3>Join Rentid Waitlist Program</h3>
                                <p>Get early access to tools that transform your rental business. Join the Rentid Waitlist Program today.</p>
                                <Link to="https://app.rentid.io/sign-up" className="btn btnBlue">VIP Onboarding</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END signupDriveMain */}

            {/* START signupDriveMain */}
            <section className='signupDriveMain generalConversationsMain'>
                <div className='container'> 
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='headSignupDrive'>
                                <h2>General conversations</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner'>
                                <h3>General Questions</h3>
                                <p>Have questions? We’ve got answers! Explore everything you need to know about Rentid 
                                and how it works for you.</p>
                                <a href="/general-question" className="btn btnBlue">Contact Us</a>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner generalConversationsComing'>
                                <h3>Resource Center for Guest</h3>
                                <p>Coming soon: Your go-to Resource Center for all things Rentid! Answers, tips, and support made just for you.</p>
                                <Link href="#" className="btn btnTextBlue">Coming Soon</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END generalConversationsMain */}


            {/* START bookingMeetingsMain */}
            <section className='bookingMeetingsMain'>
                <div className='container'> 
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='headSignupDrive'>
                                <h2>Booking meetings with experts</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-4 col-md-6 col-sm-12 col-12'>
                            <div className='bookingMeetingsInner'>
                                <img width="80px" src="./img/sales_team_icon.svg" alt="Sales Team"/>
                                <h3>Sales Team</h3>
                                <p>Discover how Rentid can empower your business—schedule a call with our Sales Team today.</p>
                                <a href="https://calendar.app.google/nKnVSwzzM7c8XaQo8" target='_blank' rel="noreferrer" className="btn btnBlue">Book Meeting</a>
                                <a href="/" className="btn btnTextBlue">Explore Products</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 col-12'>
                            <div className='bookingMeetingsInner'>
                                <img width="80px" src="./img/success_manager_icon.svg" alt="Success Manager"/>
                                <h3>Success Manager</h3>
                                <p>Need help maximizing your rental operations? Book a session with your dedicated Success Manager.</p>
                                <a href="https://calendar.app.google/CwhwqCeHs1yoQqMA6" target='_blank' rel="noreferrer" className="btn btnBlue">Book Meeting</a>
                                <a href="/rentsuccess" className="btn btnTextBlue">Explore Success</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 col-12'>
                            <div className='bookingMeetingsInner'>
                            <img width="80px" src="./img/technical_support_icon.svg" alt="Technical Support"/>
                                <h3>Technical Support</h3>
                                <p>Facing technical issues? Get the support you need—book a meeting with our Tech Team.</p>
                                <a href="/" className="btn btnBlue">Submit Ticket</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bookingMeetingsMain */}


            {/* START addInquiriesMain */}
            <section className='signupDriveMain addInquiriesMain'>
                <div className='container'> 
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='headSignupDrive'>
                                <h2>Additional inquiries</h2>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner'>
                                <h3>Press & Media</h3>
                                <p>For press inquiries, media kits, or interview requests, reach out to our team. 
                                Let’s share the story of Rentid together. </p>
                                <a href="mailto:press@rentid.io" className="btn btnBlue">Contact Us</a>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner'>
                                <h3>Social Media</h3>
                                <ul className="socialMedia">
                                <li>
                                    <a href="https://www.facebook.com/profile.php?id=100087781668300" target="_blank" rel="noreferrer"><img src="/img/facebook-01.svg" alt="Rentid Facebook" width="57px"/></a>
                                </li>
                                <li>
                                    <a href="/" target="_blank"><img src="/img/youtube.svg" alt="" width="57px"/></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/rentid.io/" target="_blank"  rel="noreferrer"><img src="/img/instagram.svg" alt="Rentid Instagram" width="57px"/></a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/rentidinc/" target="_blank"  rel="noreferrer"><img src="/img/linkedin-01.svg" alt="Rentid LinkedIn" width="57px"/></a>
                                </li>
                                <li>
                                    <a href="https://x.com/Rentid_" target="_blank"  rel="noreferrer"><img src="/img/twitter_icon.svg" alt="Rentid X/Twitter" width="57px"/></a>
                                </li>
                                <li>
                                    <a href="/" target="_blank"><img src="/img/tiktok_icon.svg" alt="" width="57px"/></a>
                                </li>
                            </ul>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner'>
                                <h3>Affiliates</h3>
                                <p>Join our affiliate program and start earning by sharing Rentid with your network. 
                                Sign up today and grow with us</p>
                                <a href="/apply-affilates" className="btn btnBlue">Sign Up</a>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                            <div className='signupDriveInner'>
                                <h3>Investor Relations</h3>
                                <p>Connect with us about Rentid's vision, growth strategy, and opportunities for investment. 
                                Let’s build the future of mobility together.</p>
                                <a href="/investor-relation" className="btn btnBlue">Contact Us</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END addInquiriesMain */}


            {/* START start-for-free */}
            <section className="start-for-free">
                <div className="row">
                    <div className="col-md-12 main-heading-text1 text-center">
                        <ScrollingMarquee/>
                        <p>Join our <span>beta test group</span> - there’s only upside from here. </p>
                        {/* <p className="free-text"><img src="/img/time.svg" alt="" className="img-fluid" />Takes less than 10 minutes</p> */}
                    </div>
                    <div className="beta-user">
                        {/* <button  className="btn-getstarted1 d-lg-block1 openModal" data-bs-toggle="modal" data-bs-target="#exampleModal">Become a Beta User</button> */}
                          <Link to="https://app.rentid.io/sign-up" className="btn-getstarted1 d-lg-block1">VIP Onboarding</Link>
                    </div>
                </div>
            </section>
        {/* END start-for-free */}
        {/* <BetaForm/> */}

        <Footer/>
        </>
    )
}
export default Contactuspage;